<template>
  <tr>
    <th v-for="(item,index) of headers" :key="index" :class="[item.sort.order, item.class]" @click="headerClicked(index)">
      <a href="#" :class="{'fullTable-sorter': item.sort.sorteable}" >{{ item.title }}</a>
    </th>
  </tr>
</template>
<script>

export default {
  name: "Header",
  props: {
    headers: {
      type: Array,
      default: () => ([
        {
          title: "",
          column:"",
          sort: {
            sorteable: false,
            order:"desc"
          }
        }
      ])
    },
    listFilters: {
      type: Object,
      default: null,
    },
  },
  emits: ['changed-header', 'change'],
  data() {
    return {
      sort: {
        index: -1,
        header: "",
        order: "desc",
      },
      bar: this.headers,
    }
  },
  watch:{
    optionSelected(val){
      if (val != this.current) {
        this.$emit('change', val);
      }
    },
  },
  mounted() {},
  methods: {
    headerClicked(index) {
      if (!this.headers[index].sort.sorteable){
        return;
      }
      let oldOrder= this.bar[index].sort.order;
      this.bar[index].sort.order = oldOrder=="desc"?"asc": "desc";
      if (this.sort.index!=-1 && index!= this.sort.index){
        this.bar[this.sort.index].sort.order="";
      }
      this.sort = {
        index:index,
        order: this.bar[index].sort.order,
        header:this.bar[index].title,
        column: this.bar[index].column,
      };
      this.$emit('changed-header', this.sort);

    },
    getClasses(index) {
      if(!this.bar[index].sort.sorteable){
        return;
      }
      return this.bar[index].sort.order;
    },
  }
};
</script>
<style scoped>
.desc a {
    padding-right: 1.5rem;
}
.asc a {
    padding-right: 1.5rem;
}
</style>
